import * as Yup from 'yup';

export interface IJobDetails {
  service_group: string;
  service_sub_group?: string;
  mode_of_entry: string;
  psc_merit_number: number | null;
  batch: string;
  trainee_type: string;
}

export const jobDetailsInitialValue = {
  service_group: '',
  service_sub_group: '',
  mode_of_entry: '',
  psc_merit_number: null,
  batch: '1',

  trainee_type: ''
};

export const JobDetailsSchemaValidation = Yup.object().shape({
  service_group: Yup.string().required('Service Group is required'),
  service_sub_group: Yup.string().required('Service Group is required'),

  mode_of_entry: Yup.string().required('Mode of entry is required'),
  psc_merit_number: Yup.string().nullable(),
  batch: Yup.string().optional(),
  trainee_type: Yup.string().required('Trainee type is required')
});

export const traineeType: Array<{
  label: string;
  value: string;
}> = [
  {
    label: 'BAT',
    value: '1'
  },
  {
    label: 'Others',
    value: '2'
  }
];

export const modeOfEntry: Array<{
  label: string;
  value: string;
}> = [
  {
    label: 'Open',
    value: '1'
  },
  {
    label: 'Indigenous',
    value: '2'
  },
  {
    label: 'Women',
    value: '3'
  },
  {
    label: 'Madhesi',
    value: '4'
  },
  {
    label: 'Backward Area',
    value: '5'
  },
  {
    label: 'Physically Disabled',
    value: '6'
  }
];

export const BatchOptions: {
  label: string;
  value: string;
}[] = Array(100)
  .fill(0)
  .map((_, i) => {
    return {
      label: (i + 1).toString(),
      value: (i + 1).toString()
    };
  });
